import React, { useRef, useEffect } from 'react';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';

interface ZenAnimationWrapperProps {
  children: React.ReactNode;
  animation?: 'fade' | 'slide' | 'float' | 'breathe' | 'glow';
  delay?: number;
  className?: string;
  once?: boolean;
}

export const ZenAnimationWrapper: React.FC<ZenAnimationWrapperProps> = ({
  children,
  animation = 'fade',
  delay = 0,
  className = '',
  once = true,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const { isVisible, setElement } = useScrollAnimation({ triggerOnce: once });

  useEffect(() => {
    if (ref.current) {
      setElement(ref.current);
    }
  }, [setElement]);

  const getAnimationClass = () => {
    switch (animation) {
      case 'fade':
        return isVisible ? 'zen-fade' : 'opacity-0 translate-y-5';
      case 'slide':
        return isVisible ? 'zen-slide' : 'opacity-0 -translate-x-8';
      case 'float':
        return isVisible ? 'zen-float' : '';
      case 'breathe':
        return isVisible ? 'zen-breathe' : '';
      case 'glow':
        return isVisible ? 'zen-glow' : '';
      default:
        return '';
    }
  };

  const animationDelay = delay > 0 ? { animationDelay: `${delay}ms` } : {};

  return (
    <div
      ref={ref}
      className={`transition-all duration-300 ${getAnimationClass()} ${className}`}
      style={animationDelay}
    >
      {children}
    </div>
  );
};

export default ZenAnimationWrapper;